import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
    Box
} from '@mui/material'
import { ReactComponent as CloseIcon } from "src/v2/assets/icons/close-icon.svg"
import ButtonWithIcon from "../../../../components/Button/Button"
import TextFieldInput from "../../../../components/Input/text-field-input"
import { ReactComponent as ArrowRightIcon } from "src/v2/assets/icons/arrow-right-icon.svg"

const DuplicarModal = ({ open, onClose, onConfirm, rowOriginal }) => {
    const [novoCetip, setNovoCetip] = useState('')
    const [novaVersao, setNovaVersao] = useState('')

    const desabilitado = !novoCetip || !novaVersao

    const handleConfirmar = () => {
        const payloadProximaTela = {
            original: rowOriginal,
            novoCetip: novoCetip,
            novaVersao: novaVersao
        }

        onConfirm(payloadProximaTela)

        limparEFechar()
    }

    const limparEFechar = () => {
        setNovoCetip('')
        setNovaVersao('')
        onClose()
    }

    const darkInputStyles = {
        width: '160px',

        '& .MuiOutlinedInput-root': {
            height: '48px',

            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'icon.main'
            }
        },

        '& .MuiInputBase-input': {
            color: 'common.white',
            padding: '20px 12px 4px 12px',
            height: 'auto', 
        },

        '& .MuiInputLabel-root': {
            color: 'input.label.secondary',
        },

        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'input.borderColor.white70'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'common.white'
        },
    }



    return (
        <Dialog
            open={open}
            onClose={limparEFechar}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: 'background.paper',
                    color: 'common.white'
                }
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '24px 24px 0 24px' }}>
                <Typography variant="h3" sx={{ color: 'common.white', lineHeight: '37px' }}>
                    Duplicar
                </Typography>
                <IconButton onClick={limparEFechar} sx={{ color: 'icon.main' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ mt: 2, paddingLeft: '24px', paddingRight: '24px', paddingBottom: 0 }}>
                <Typography variant="body2" sx={{ mb: 3, color: 'input.label.secondary' }}>
                    Informe a CETIP e Versão do novo Documento:
                </Typography>

                <Box sx={{ display: 'flex', gap: '24px' }}>

                    <TextFieldInput
                        label="CETIP"
                        value={novoCetip}
                        onChange={(e) => setNovoCetip(e.target.value)}
                        sx={darkInputStyles}
                    />

                    <TextFieldInput
                        label="Versão documento"
                        value={novaVersao}
                        onChange={(e) => setNovaVersao(e.target.value)}
                        sx={darkInputStyles}
                    />

                </Box>
            </DialogContent>

            <DialogActions sx={{ padding: "24px", justifyContent: 'flex-end' }}>
                <ButtonWithIcon
                    onClick={handleConfirmar}
                    disabled={desabilitado}
                    startIcon={<ArrowRightIcon />}
                    sx={{
                        width: '140px',
                        height: '36px',
                        borderRadius: '40px',
                        border: '1px solid',
                        padding: 0,
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',

                        borderColor: 'input.borderColor.white70',
                        color: 'common.white',

                        '& .MuiButton-startIcon': {
                            color: 'icon.main'
                        },

                        '&:hover': {
                            backgroundColor: 'transparent.white10'
                        },

                        '&.Mui-disabled': {
                            color: 'icon.disabled',
                        }
                    }}
                >
                    CADASTRAR
                </ButtonWithIcon>
            </DialogActions>
        </Dialog>
    )
}

DuplicarModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    rowOriginal: PropTypes.object
}

export default DuplicarModal